<template>
  <div class="checklist-editor-toolbar qrw-box-shadow-16dp">
    <ChecklistEditorToolbarButton
      @click="$emit('click', 'STATIC_TEXT')"
      icon="type"
      :text="$t('checklist_toolbar.text')"
    />
    <ChecklistEditorToolbarButton
      @click="$emit('click', 'DIVIDER')"
      icon="divider"
      :text="$t('checklist_toolbar.divider')"
    />
    <ChecklistEditorToolbarButton
      @click="$emit('click', 'MEDIA_FILE')"
      icon="image"
      :text="$t('checklist_toolbar.image')"
    />
    <ChecklistEditorToolbarButton
      @click="$emit('click', 'DOCUMENT_FILE')"
      icon="paperclip"
      :text="$t('checklist_toolbar.document')"
    />
    <BaseDivider
      vertical
      color="border-base-tertiary-secondary"
      style="height: 32px"
    />
    <ChecklistEditorToolbarButton
      @click="$emit('click', 'CHECKLIST')"
      icon="check-square"
      :text="$t('checklist_toolbar.checklist')"
    />
    <ChecklistEditorToolbarButton
      @click="$emit('click', 'TEXT_INPUT')"
      icon="text-input"
      :text="$t('checklist_toolbar.input')"
    />
    <ChecklistEditorToolbarButton
      @click="$emit('click', 'NUMBER')"
      icon="hash"
      :text="$t('checklist_toolbar.number')"
    />
    <ChecklistEditorToolbarButton
      @click="$emit('click', 'OPTIONS')"
      icon="list"
      :text="$t('checklist_toolbar.options')"
    />
    <ChecklistEditorToolbarButton
      @click="$emit('click', 'FILE_UPLOAD')"
      icon="paperclip"
      :text="$t('checklist_toolbar.file')"
    />
  </div>
</template>

<script>
import ChecklistEditorToolbarButton from "./ChecklistEditorToolbarButton.vue";

export default {
  components: {
    ChecklistEditorToolbarButton,
  },
};
</script>

<style scoped>
.checklist-editor-toolbar {
  border-radius: 10px;
  display: flex;
  padding: 6px;
  background: var(--qrw-background-base-inverse-primary);
  color: var(--qrw-content-base-inverse-primary);
  align-items: center;
  column-gap: 6px;

  position: fixed;
  bottom: 40px;
  left: 256px;
  right: 0;
  margin: 0 auto;

  z-index: 30;

  width: fit-content;
}
</style>
